// link de WhatsApp — usado em todos os CTAs da página /portfolio
export const WHATSAPP_URL =
  "https://wa.me/5553991421888?text=Ol%C3%A1!%20Vi%20seu%20media%20kit%20e%20gostaria%20de%20conversar%20sobre%20uma%20poss%C3%ADvel%20parceria";

// prints de insights gerais da conta (public/portfolio/) — prova visual dos números
export const GENERAL_PRINTS: { src: string; label: string }[] = [
  { src: "/portfolio/insight-geral.jpg", label: "visão geral da conta" },
  { src: "/portfolio/insight-publico.jpg", label: "público e demografia" },
  { src: "/portfolio/geral-views.jpg", label: "visualizações" },
  { src: "/portfolio/geral-alcance.jpg", label: "contas alcançadas" },
  { src: "/portfolio/geral-seguidores.jpg", label: "seguidores vs não seguidores" },
  { src: "/portfolio/geral-curtidas.jpg", label: "curtidas" },
  { src: "/portfolio/geral-comentarios.jpg", label: "comentários" },
  { src: "/portfolio/geral-reposts.jpg", label: "reposts" },
  { src: "/portfolio/geral-compartilhamentos.jpg", label: "compartilhamentos" },
  { src: "/portfolio/geral-salvamentos.jpg", label: "salvamentos" },
];

// 16 prints de insight de reels — grid de prova, sem legenda por vídeo
export const REEL_PRINTS: string[] = Array.from(
  { length: 16 },
  (_, i) => `/portfolio/reel-${String(i + 1).padStart(2, "0")}.jpg`,
);

// 5 prints de insight de posts estáticos — grid de prova, sem legenda
export const STATIC_PRINTS: string[] = Array.from(
  { length: 5 },
  (_, i) => `/portfolio/estatico-${i + 1}.jpg`,
);

// vídeo das notificações de venda em <24h (prova de conversão)
export const SALES_VIDEO = "/portfolio/vendas-24h.mp4";
export const SALES_POSTER = "/portfolio/vendas-24h-poster.jpg";
